export const userProfileServiceTypes = {
    downloadServerStrategy: Symbol('UserProfileDownloadServerStrategy'),
} as const;
